import { useMemo } from 'react';
import { useControllerSelector } from '@ayocore/platform/client/controllers/useControllerSelector';
import { AssistantChatController, type AssistantChatState } from './AssistantChatController';

/**
 * Хук доступа к состоянию чата ассистента (Controller + useSyncExternalStore).
 * Подписка точечная — через селектор с shallow-мемоизацией.
 *
 * Действия дергаются напрямую у контроллера: `AssistantChatController.getInstance().sendMessage(...)`.
 * Статусы tool calls / pendingUserInput — из `useLlmStreamController` (один источник истины).
 */
export function useAssistantChat<TSelected>(
  selector: (state: AssistantChatState) => TSelected
): TSelected {
  const controller = useMemo(() => AssistantChatController.getInstance(), []);
  return useControllerSelector(controller, selector);
}
